module.exports = __webpack_public_path__ + "static/media/kids.9343ad47.PNG";